export const formatSelectData = (data) => {
	const { nameRu, nameKz, ...props } = data
	return { rus: nameRu, kz: nameKz, ...props }
}
